<template>
  <el-dialog :visible.sync="treeDialog" title="编辑菜单权限" class="dialogTree">
    <el-tree
      :props="defaultProps"
      :data="loadData"
      node-key="id"
      show-checkbox
      center
      ref="treeRef"
      :default-checked-keys="defaultCheckedNodes"
    >
    </el-tree>
    <span slot="footer" class="dialog-footer">
      <el-button @click="treeDialog = false">取 消</el-button>
      <el-button type="primary" @click="editPermit()">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { updateMenuPermitApi } from '@/api/user.js';
export default {
  props: ['loadData', 'defaultCheckedNodes', 'menuObj'],
  inject: ['reload'],
  data() {
    return {
      permitData: {},
      treeDialog: false,
      defaultProps: {
        children: 'childs',
        label: 'name',
      },
    };
  },
  mounted() {
    // this
    // this.$refs.treeRef.setCheckedNodes(this.defaultCheckedNodes)
  },
  methods: {
    async editPermit() {
      let allCheckedNodes = this.$refs.treeRef.getCheckedNodes();
      let obj = {};
      allCheckedNodes.forEach((item) => {
        if (!item.childs) {
          if (!obj[item.menuId]) {
            obj[item.menuId] = [];
          }
          obj[item.menuId].push(item.permitId);
        }
      });
      const res = await updateMenuPermitApi({ ...this.menuObj, ...obj });
      if (res.code === 200) {
        this.$message.success('修改成功');
        this.reload();
      }
    },
  },
};
</script>
<style lang="less" scoped>
// .dialogTree{
//     height: 600px;
//     overflow: scroll;
// }
</style>